// packages/web/src/components/admin/email-templates/send-test-dialog.tsx
import { toast } from "sonner";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useSendTestEmail } from "@/api/email-templates/mutations";

interface Props {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  templateKey: string;
  locale: string;
  draft: { subject: string; slots: Record<string, string> };
  sampleVars: Record<string, unknown>;
}

export function SendTestDialog({
  open,
  onOpenChange,
  templateKey,
  locale,
  draft,
  sampleVars,
}: Props) {
  const sendTest = useSendTestEmail();

  async function handleSend() {
    try {
      await sendTest.mutateAsync({
        key: templateKey,
        body: {
          locale,
          subject: draft.subject,
          slots: draft.slots,
          sampleVars,
        },
      });
      toast.success("Testmail verstuurd");
      onOpenChange(false);
    } catch (err) {
      toast.error((err as Error).message);
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent showCloseButton={false}>
        <DialogHeader>
          <DialogTitle>Testmail sturen</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-ink-700">
          We sturen deze versie naar je eigen adres. Je kunt 10 testmails per minuut sturen.
        </p>
        <DialogFooter>
          <Button type="button" variant="ghost" onClick={() => onOpenChange(false)}>
            Annuleren
          </Button>
          <Button
            type="button"
            variant="primary"
            onClick={handleSend}
            disabled={sendTest.isPending}
          >
            Versturen
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
